// level: 3 = core (daily, shipped production), 2 = working (used in real projects), 1 = familiar
// refs: where it was used — experience ids map to the role colors in graphPalette.js
const EARNIE = { type: 'experience', id: 'earnie', label: 'Earnie V2' };
const WIA = { type: 'experience', id: 'winitall', label: 'Win It All' };
const IDTECH = { type: 'experience', id: 'idtech', label: 'iD Tech' };
const WHITMAN = { type: 'experience', id: 'whitman', label: 'Whitman College' };
const proj = (id, label) => ({ type: 'project', id, label });

// Shown as large cards at the top of the section
export const CORE_STACK = [
  { name: 'TypeScript', icon: 'code', level: 3, blurb: '~115K LOC across a multi-tenant SaaS', refs: [EARNIE] },
  { name: 'React', icon: 'layout', level: 3, blurb: '130+ components, Refine admin panels', refs: [EARNIE, WIA] },
  { name: 'Kotlin · Spring Boot', icon: 'server', level: 3, blurb: 'REST API + scheduler microservice', refs: [WIA] },
  { name: 'Flutter', icon: 'smartphone', level: 2, blurb: 'iOS / Android / Web from one codebase', refs: [WIA] },
  { name: 'PostgreSQL', icon: 'database', level: 3, blurb: 'RLS, 95+ migrations, Supabase', refs: [EARNIE] },
  { name: 'Azure · Terraform', icon: 'cloud', level: 2, blurb: 'Production infra as code', refs: [WIA] },
  { name: 'Python', icon: 'terminal', level: 2, blurb: 'Automation, data, Discord bots', refs: [WHITMAN] },
  { name: 'Payments & KYC', icon: 'shield', level: 2, blurb: 'Stripe, PaySafe, 3DS, GBG identity', refs: [EARNIE, WIA] },
];

export const SKILLS = [
  {
    category: 'Languages',
    icon: 'terminal',
    skills: [
      { name: 'TypeScript', level: 3, refs: [EARNIE] },
      { name: 'Kotlin', level: 3, refs: [WIA] },
      { name: 'Dart', level: 2, refs: [WIA] },
      { name: 'SQL', level: 3, refs: [EARNIE, WIA] },
      { name: 'Python', level: 2, refs: [WHITMAN] },
      { name: 'Java', level: 2, refs: [IDTECH, proj('guro-guro', 'Guro-guro')] },
      { name: 'C++', level: 1, refs: [IDTECH] },
      { name: 'Go', level: 1, refs: [proj('go-cache', 'Go Cache Service')] },
      { name: 'R', level: 1, refs: [WHITMAN] },
    ],
  },
  {
    category: 'Frontend & Mobile',
    icon: 'layers',
    skills: [
      { name: 'React', level: 3, refs: [EARNIE, WIA, proj('todo', 'React To-Do')] },
      { name: 'Flutter', level: 2, refs: [WIA] },
      { name: 'Refine', level: 2, refs: [WIA] },
      { name: 'HTML / CSS', level: 3, refs: [WHITMAN, proj('todo', 'React To-Do')] },
      { name: 'Supabase Realtime', level: 2, refs: [EARNIE] },
    ],
  },
  {
    category: 'Backend & Data',
    icon: 'server',
    skills: [
      { name: 'Hono', level: 3, refs: [EARNIE] },
      { name: 'Spring Boot', level: 3, refs: [WIA] },
      { name: 'PostgreSQL', level: 3, refs: [EARNIE] },
      { name: 'Supabase', level: 3, refs: [EARNIE] },
      { name: 'Row-Level Security', level: 3, refs: [EARNIE] },
      { name: 'Redis', level: 2, refs: [WIA] },
      { name: 'REST API design', level: 3, refs: [EARNIE, WIA] },
      { name: 'gRPC', level: 1, refs: [proj('go-cache', 'Go Cache Service')] },
    ],
  },
  {
    category: 'Cloud & DevOps',
    icon: 'cloud',
    skills: [
      { name: 'Azure', level: 2, refs: [WIA] },
      { name: 'Terraform', level: 2, refs: [WIA] },
      { name: 'Supabase Edge Functions', level: 3, refs: [EARNIE] },
      { name: 'Vercel', level: 2, refs: [] },
      { name: 'Cron & schedulers', level: 2, refs: [WIA] },
      { name: 'Git', level: 3, refs: [EARNIE, WIA] },
    ],
  },
  {
    category: 'Payments & Identity',
    icon: 'shield',
    skills: [
      { name: 'Stripe', level: 2, refs: [EARNIE] },
      { name: 'PaySafe (cards, 3DS, wallets)', level: 2, refs: [WIA] },
      { name: 'GBG KYC', level: 2, refs: [WIA] },
      { name: 'Supabase Auth & MFA', level: 3, refs: [EARNIE] },
      { name: 'Salesforce OAuth', level: 2, refs: [EARNIE] },
      { name: 'Radar geofencing', level: 2, refs: [WIA] },
    ],
  },
  {
    category: 'Data & Analysis',
    icon: 'chart',
    skills: [
      { name: 'Pandas / NumPy', level: 2, refs: [WHITMAN] },
      { name: 'ggplot2 & Shiny', level: 2, refs: [WHITMAN] },
      { name: 'Statistical analysis', level: 2, refs: [WHITMAN] },
      { name: 'SportsData.io', level: 1, refs: [WIA] },
    ],
  },
  {
    category: 'Practices',
    icon: 'users',
    skills: [
      { name: 'Multi-tenant architecture', level: 3, refs: [EARNIE] },
      { name: 'Requirements gathering', level: 2, refs: [WHITMAN, EARNIE] },
      { name: 'Agile', level: 2, refs: [proj('guro-guro', 'Guro-guro')] },
      { name: 'Teaching & mentoring', level: 2, refs: [IDTECH] },
      { name: 'UI/UX & wireframing', level: 2, refs: [WHITMAN, EARNIE] },
    ],
  },
];

// experience id → index into ROLE_COLORS (same order as EXPERIENCE)
export const ROLE_INDEX = { earnie: 0, winitall: 1, idtech: 2, whitman: 3 };
